import i18n from 'i18next'

export const getContentMenuLabels = () => ({
  titleLabel: i18n.t('editor:contentMenu.title'),
  subTitleLabel: i18n.t('editor:contentMenu.subTitle'),
  bodyTextLabel: i18n.t('editor:contentMenu.bodyText'),
  vignetteLabel: i18n.t('editor:contentMenu.vignette'),
  preambleLabel: i18n.t('editor:contentMenu.preamble'),
  tvListingLabel: i18n.t('editor:contentMenu.tvListing'),
  unorderedLabel: i18n.t('editor:contentMenu.unorderedList'),
  orderedLabel: i18n.t('editor:contentMenu.orderedList'),
  characterCountLabel: i18n.t('editor:numberOfChars')
})
